module.exports = __webpack_public_path__ + "img/lg_ring_y_c_1_1.59057990.png";